var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"progress"},[_c('div',{staticClass:"progress__bar",style:({ width: _vm.step+'%' })},[_c('div',{staticClass:"bar__info"},[_c('div',{staticClass:"bar__reached"},[_vm._v(_vm._s(_vm.step)+"%")])])])])}
var staticRenderFns = []

export { render, staticRenderFns }